/* eslint-disable curly */
/* eslint-disable prettier/prettier */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
import { useLazyQuery } from "@vue/apollo-composable";
import { GetPagesDocument } from "@/core/api/graphql/types";
import type { GetPagesQueryVariables, PageConnection, PageType } from "@/core/api/graphql/types";
import type { MaybeRefOrGetter } from "vue";

export function useGetPages(payload: MaybeRefOrGetter<GetPagesQueryVariables>) {
  return useLazyQuery(GetPagesDocument, payload, { fetchPolicy: "cache-first" });
}

export async function getPages(pagesQueryParameters: GetPagesQueryVariables) : Promise<PageType[]>
{
  const pagesQuery = useLazyQuery(GetPagesDocument, pagesQueryParameters, { fetchPolicy: "cache-first" });

  const result = await pagesQuery.load();

  if (pagesQuery.error.value)
    throw `Error fetching pages by params '${JSON.stringify(pagesQueryParameters)}': ${JSON.stringify(pagesQuery.error.value)}`;

  if (result)
  {
    const data : PageConnection = result.pages as PageConnection;
    return data?.items ?? [];
  }
  
  return [];
}
